"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { tv } from "tailwind-variants";
import { Button } from "@/common/components/button";
import { useTranslations } from "@/services/i18n";
import { monsterrat } from "@/services/styles/fonts";

export function NotFoundPageView() {
  const t = useTranslations("pages.404");
  const router = useRouter();

  return (
    <div
      className={tv({
        base: [
          "flex animate-delay-200 animate-duration-300 animate-fade flex-col items-center justify-center",
          "py-6 lg:pt-0 lg:pb-16 2xl:pb-24",
        ],
      })()}
    >
      <div className="text-center lg:max-w-[725px] 2xl:max-w-none">
        <Image src="/next-assets/404.svg" alt="404" width={800} height={400} />
      </div>
      <div className="flex flex-col items-center justify-center gap-5">
        <h1 className={tv({ base: ["font-semibold text-3xl lg:text-7xl", monsterrat.className] })()}>{t("heading")}</h1>
        <p className="text-xl lg:text-4xl">{t("subheading")}</p>
        <div className="mt-5 flex flex-col items-center justify-center gap-3">
          <Button variant="cta" size="xl" onClick={() => router.push("/")}>
            {t("cta_home")}
          </Button>
          <button type="button" className="text-sm" onClick={() => router.back()}>
            {t("cta_back")}
          </button>
        </div>
      </div>
    </div>
  );
}
